//import React from "react"
import styled from "styled-components"
import { slideFromTop } from "./animations"

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`
export const DropdownMenu = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 2rem;
  max-height: 50vh;
  min-width: 15rem;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${(props) => props.theme.colours.paperSolid};
  border-radius: 0 0 ${(props) => props.theme.corners}
    ${(props) => props.theme.corners};
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
  animation: 0.3s ${slideFromTop} ease-out;
`
export const DropdownMenuItem = styled.div`
  display: flex;
  font-weight: normal;
  align-items: center;
  justify-content: flex-start;
  cursor: ${(props) => (props.onClick != null ? "pointer" : "default")};
  padding: 0.5rem;
  background-color: transparent;
  transition: all 0.3s ease-out;
  text-align: left;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`
